const pillsTab = document.querySelector('[data-product-pills-tab]');
const pillsTabContent = document.querySelector('[data-pills-tab-content]');
const tabs = pillsTab.querySelectorAll('[data-nav-link]');
const tabPanes = pillsTabContent.querySelectorAll('[data-tab-pane]');
const mobileAccordion = document.querySelector('[data-product-details-tab-mobile]');
const accordions = mobileAccordion.querySelectorAll('[data-accordion-toggle]');

accordions.forEach((accordionTab) => {
  accordionTab.addEventListener('click', (event) => {
    handleAccordionTabClick(event);
  });
});

tabs.forEach((tab) => {
  tab.addEventListener('click', (event) => {
    handleTabClick(event);
  });
});

function handleTabClick(event) {
  const targetTab = event.currentTarget;
  const targetTabBlockId = targetTab.getAttribute('data-target').split('#collapse--')[1];

  tabs.forEach((tab) => {
    tab.id === targetTab.id ? tab.classList.add('active') : tab.classList.remove('active');
  });
  tabPanes.forEach((tab) => {
    tab.id === targetTabBlockId ? tab.classList.add('active', 'show') : tab.classList.remove('active', 'show');
  });
}

function handleAccordionTabClick(event) {
  const targetTab = event.currentTarget;
  const targetTabBlockId = 'collapse--' + targetTab.getAttribute('data-target').split('#collapse--')[1];
  const accordionToggle = mobileAccordion.querySelectorAll('[data-accordion-toggle]');
  const collapse = mobileAccordion.querySelectorAll('[data-mobile-collapse]');

  accordionToggle.forEach((elem) => {
    elem == targetTab && elem.getAttribute('aria-expanded') != 'true' ? elem.setAttribute('aria-expanded', 'true') : elem.setAttribute('aria-expanded', 'false');
  });
  collapse.forEach((elem) => {
    elem.id == targetTabBlockId && elem.classList.contains('show') == false ? elem.classList.add('show') : elem.classList.remove('show');
  });
}
